import React from 'react';

import appErrorService from '../../../services/app/appErrorService';
import ConnectionTrackButton from '../ConnectionTrackButton/ConnectionTrackButton';

const InternetAndDeviceTrackButton = (props) => {
    const {isDeviceReady, ...restProps} = props;
    const {button: Component} = restProps;
    const showDisconnectedMessage = () => {
        appErrorService.showDeviceDisconnectNotification();
    };

    return isDeviceReady ? (
        <ConnectionTrackButton {...restProps} />
    ) : (
        <Component {...restProps} onClick={showDisconnectedMessage} onChange={showDisconnectedMessage} />
    );
};

export default InternetAndDeviceTrackButton;
